import React, { useState, useEffect } from "react";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import MuiAlert from "@material-ui/lab/Alert";
import { useFormik, Field, Formik, FormikProvider } from "formik";
import TextField from "@material-ui/core/TextField";
import * as yup from "yup";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { CircularProgress } from "@material-ui/core";
import CustomImageInput from "../Form/CustomImageInput/Index";
import Radio from "@material-ui/core/Radio";
import { Link } from "react-router-dom"
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import './editor.css'

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btnTab: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnTabActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px",
        maxWidth: "230px",
        backgroundColor: "#950000",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#950000",
            boxShadow: "none",
        },
        color: "#fff",
        width: "100%",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
        width: '100%'
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    mr: {
        marginLeft: "5px",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "170px",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#616161",
        border: "1px solid #D0D0D0",
        borderBottom: "none",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px 10px 0px 0px",
        maxWidth: "170px",
        backgroundColor: "#ffffff",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#ffffff",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    formControl: {
        margin: theme.spacing(1),
        width: "100%",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
    },
    danger: {
        color: "red",
    },
    select: {
        borderRadius: "10px",
        width: "100%",
        height: "34px",
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    input: {
        background: "#F5F5F5",
        border: "1px solid #A7A7A7",
        borderRadius: "10px",
        width: "99%",
        height: "40px",
        fontSize: "17px",
        "&:focus": {
            outline: " none !important",
        },
    },
    label: {
        lineHeight: "42px",
        fontSize: "15px",
        fontWeight: "normal",
    },
    mute: {
        color: "#808080",
    },
    textarea: {
        background: "#F5F5F5",
        border: "1px solid #A7A7A7",
        borderRadius: "10px",
        maxWidth: "98%",
        minWidth: "95%",
        padding: "10px",
        fontSize: "17px",
        "&:focus": {
            outline: " none !important",
        },
    },
    show: {
        display: "block",
    },
    hide: {
        display: "none",
    },
}));

let cat = [];
let subCat = [];
let subSecCat = [];
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const FILE_SIZE = 160 * 1024 * 160;

const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/gif", "image/png"];

const validationSchema = yup.object({
    category: yup
        .string("دسته بندی محصول را وارد کنید.")
        .required("دسته بندی محصول الزامی می باشد."),
    subCategory1: yup
        .string("زیر مجموعه را وارد کنید.")
        .required("زیر مجموعه الزامی می باشد."),
    SecondarySubCategoryId: yup
        .string("زیر مجموعه فرعی را وارد کنید.")
        .required("زیر مجموعه فرعی الزامی می باشد."),
    Title: yup
        .string("نام محصول را وارد کنید.")
        .required("نام محصول الزامی می باشد."),
    UnitPrice: yup
        .string("قیمت محصول را وارد کنید.")
        .required("قیمت محصول الزامی می باشد.")
        .matches(/^[0-9]+$/, "قیمت محصول تنها شامل اعداد است."),
    NumberPack250: yup
        .string("موجودی انبار را وارد کنید.")
        .required("موجودی انبار الزامی می باشد.")
        .matches(/^[0-9]+$/, "موجودی انبار تنها شامل اعداد است."),
    NumberPack500: yup
        .string("موجودی انبار را وارد کنید.")
        .required("موجودی انبار الزامی می باشد.")
        .matches(/^[0-9]+$/, "موجودی انبار تنها شامل اعداد است."),
    NumberPack1000: yup
        .string("موجودی انبار را وارد کنید.")
        .required("موجودی انبار الزامی می باشد.")
        .matches(/^[0-9]+$/, "موجودی انبار تنها شامل اعداد است."),
    PropertiesTitle: yup
        .string("عنوان خاص محصول را وارد کنید.")
        .required("عنوان خاص محصول الزامی می باشد."),
    Image: yup.mixed().required("لطفا یک عکس انتخاب کنید"),
    StarRating: yup.string().required(),
    bulkSale: yup.string().required("انتخاب نوع بسته بندی الزامی است")
});

const ProductInsert = () => {
    const classes = useStyles();
    const [persian, setPersian] = useState(true);
    const [arabic, setArabic] = useState(false);
    const [svCategory, setSvCategory] = useState([]);
    const [svSubCategory, setSvSubCategory] = useState([]);
    const [svSubSecCategory, setSvSubSecCategory] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isBulkSale, setIsBulkSale] = useState(true);
    const [loadings, setLoadings] = useState({
        load1: false,
        load2: false,
        load3: false,
    });
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    const TogglePersian = () => {
        setArabic(false);
        setPersian(true);
    };
    const ToggleArabic = () => {
        setPersian(false);
        setArabic(true);
    };
    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };
    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };
    useEffect(() => {
        const getCats = async () => {
            setLoadings({
                load1: true,
                load2: false,
                load3: false,
            });
            const config = {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "Content-Type": "application/json",
                },
            };
            try {
                const { data } = await axios.get(
                    "/api/products/getcategories?lan=fa",
                    config
                );
                if (data.status === "ok") {
                    cat = data.data;
                    setSvCategory(cat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                }
            } catch (e) {
                console.log(e);
                setLoadings({
                    load1: false,
                    load2: false,
                    load3: false,
                });
            }
        };
        getCats();
    }, []);
    const postProduct = async (datas) => {
        setLoading(true);
        try {
            const { data } = await axios.post(`/api/admin/products/add`, datas, {
                headers: {
                    Authorization: `Bearer ` + localStorage.getItem("token"),
                    "content-type": "multipart/form-data",
                },
            });
            if (data.status === "ok") {
                toggleOpenAlert("success", "محصول با موفقیت ثبت شد");
                setLoading(false);
            } else {
                toggleOpenAlert("error", "ثبت محصول با خطا مواجه شده است");
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            setLoading(false);
        }
    };
    const linker = (type) => {
        switch (type) {
            case 1:
                return "/api/products/getsubcategories?lan=fa&MainCategoryId=";
            case 2:
                return "/api/products/getsecondarysubcategories?lan=fa&SubCategoryId=";
        }
    };
    const handleCatAxios = async (type, catId) => {
        setLoadings({
            load1: false,
            load2: type === 1 ? true : false,
            load3: type === 2 ? true : false,
        });
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };

        try {
            const { data } = await axios.get(linker(type) + catId, config);
            if (data.status === "ok") {
                if (type === 1) {
                    subCat = data.data;
                    setSvSubCategory(subCat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                    setSvSubSecCategory({});
                } else {
                    subSecCat = data.data;
                    setSvSubSecCategory(subSecCat);
                    setLoadings({
                        load1: false,
                        load2: false,
                        load3: false,
                    });
                }
            }
        } catch (e) {
            console.log(e);
            setLoadings({
                load1: false,
                load2: false,
                load3: false,
            });
        }
    };
    return (
        <Box borderRadius={10} mt={2} mr={2} className={classes.grayBox}>
            <Box className={classes.grayerBox} borderRadius={10}>
                <Link to="/profile/products-list">
                    <Button className={classes.btnTab} variant="contained">لیست محصولات</Button>
                </Link>
                <Button className={classes.btnTabActive} variant="contained">درج محصول جدید</Button>
            </Box>
            <br />
            <Box pt={4} pb={2} px={1}>
                <Formik
                    style={{ width: "100%" }}
                    initialValues={{
                        Image: "",
                        category: "",
                        subCategory1: "",
                        StarRating: "",
                        SecondarySubCategoryId: "",
                        Title: "",
                        UnitPrice: "",
                        NumberPack250: "0",
                        NumberPack500: "0",
                        NumberPack1000: "0",
                        PropertiesTitle: "",
                        ArTitle: "",
                        ArUnitPrice: "",
                        ArPropertiesTitle: "",
                        ArPropertiesText: "",
                        bulkSale: true,
                    }}
                    onSubmit={async (values) => {
                        if (draftToHtml(convertToRaw(editorState.getCurrentContent())).length > 8) {
                            let formData = new FormData();
                            Object.keys(values).forEach(function eachKey(key) {
                                formData.append(key, values[key]);
                            });
                            const editor = draftToHtml(convertToRaw(editorState.getCurrentContent())).toString();
                            formData.append("PropertiesText", editor);
                            postProduct(formData);
                        }
                        else {
                            toggleOpenAlert('error', 'لطفا متن خواص را وارد نمایید.')
                        }
                    }}
                    validationSchema={validationSchema}
                    render={({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        values,
                        touched,
                        errors,
                        setFieldValue,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container>
                                <Grid item md={4}>
                                    <Box m={2} mt={0}>
                                        <FormControl
                                            error={touched.category && Boolean(errors.category)}
                                            fullWidth
                                            variant="outlined"
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                {loadings.load1 ? (
                                                    <CircularProgress size={12} />
                                                ) : (
                                                    "دسته بندی"
                                                )}
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                name="category"
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    handleCatAxios(1, e.target.value);
                                                }}
                                                label={
                                                    loadings.load1 ? (
                                                        <CircularProgress size={12} />
                                                    ) : (
                                                        "دسته بندی"
                                                    )
                                                }
                                                value={values.category}
                                            >
                                                <MenuItem disabled value="">
                                                    <em> انتخاب کنید</em>
                                                </MenuItem>
                                                {svCategory.length > 0 &&
                                                    svCategory.map((item) => (
                                                        <MenuItem value={item.id.toString()}>
                                                            {item.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid item md={4}>
                                    <Box mt={0} m={2}>
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            error={touched.subCategory1 && Boolean(errors.subCategory1)}
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                {loadings.load2 ? (
                                                    <CircularProgress size={12} />
                                                ) : (
                                                    "زیر مجموعه"
                                                )}
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                name="subCategory1"
                                                value={values.subCategory1}
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    handleCatAxios(2, e.target.value);
                                                }}
                                                label={
                                                    loadings.load2 ? (
                                                        <CircularProgress size={12} />
                                                    ) : (
                                                        "زیر مجموعه"
                                                    )
                                                }
                                            >
                                                <MenuItem disabled value="">
                                                    <em> انتخاب کنید</em>
                                                </MenuItem>
                                                {svSubCategory.length > 0 &&
                                                    svSubCategory.map((item) => (
                                                        <MenuItem value={item.id.toString()}>
                                                            {item.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid item md={4}>
                                    <Box m={2} mt={0}>
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            error={
                                                touched.SecondarySubCategoryId &&
                                                Boolean(errors.SecondarySubCategoryId)
                                            }
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                {loadings.load3 ? (
                                                    <CircularProgress size={12} />
                                                ) : (
                                                    "زیر مجموعه فرعی"
                                                )}
                                            </InputLabel>
                                            <Select
                                                fullWidth
                                                name="SecondarySubCategoryId"
                                                value={values.SecondarySubCategoryId}
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                onChange={handleChange}
                                                label={
                                                    loadings.load3 ? (
                                                        <CircularProgress size={12} />
                                                    ) : (
                                                        "زیر مجموعه فرعی"
                                                    )
                                                }
                                            >
                                                <MenuItem disabled value="">
                                                    <em> انتخاب کنید</em>
                                                </MenuItem>
                                                {svSubSecCategory.length > 0 &&
                                                    svSubSecCategory.map((item) => (
                                                        <MenuItem value={item.id.toString()}>
                                                            {item.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item md={3}>
                                    <Box m={2}>
                                        <Field
                                            id="Image"
                                            name="Image"
                                            component={CustomImageInput}
                                            type="image"
                                            noBtn={true}
                                            boxHeight="228px"
                                            setFieldValue={setFieldValue}
                                            errorMessage={errors["Image"] ? errors["Image"] : undefined}
                                            touched={touched["Image"]}
                                            style={{ display: "flex" }}
                                            onBlur={handleBlur}
                                        />
                                    </Box>
                                    <Box m={2} mt={0}>
                                        <FormControl
                                            error={touched.StarRating && Boolean(errors.StarRating)}
                                            fullWidth
                                            variant="outlined"
                                        >
                                            <InputLabel id="demo-simple-select-outlined-label">
                                                امتیاز محصول
                    </InputLabel>
                                            <Select
                                                fullWidth
                                                name="StarRating"
                                                labelId="demo-simple-select-outlined-label"
                                                id="demo-simple-select-outlined"
                                                onChange={(e) => {
                                                    handleChange(e);
                                                }}
                                                label="امتیاز محصول"
                                                value={values.StarRating}
                                            >
                                                <MenuItem disabled value="">
                                                    <em> انتخاب کنید</em>
                                                </MenuItem>

                                                <MenuItem value={1}>1</MenuItem>
                                                <MenuItem value={2}>2</MenuItem>
                                                <MenuItem value={3}>3</MenuItem>
                                                <MenuItem value={4}>4</MenuItem>
                                                <MenuItem value={5}>5</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid item md={9}>
                                    <Box>
                                        <Button
                                            className={persian ? classes.btnActive : classes.btn}
                                            onClick={TogglePersian}
                                        >
                                            محتوای فارسی
                  </Button>
                                        <Button
                                            className={arabic ? classes.btnActive : classes.btn}
                                            onClick={ToggleArabic}
                                        >
                                            محتوای عربی
                  </Button>
                                    </Box>
                                    <Box
                                        className={persian ? classes.show : classes.hide}
                                        pt={3}
                                        pb={3}
                                        bgcolor="#fff"
                                    >
                                        <Grid container>
                                            <Grid
                                                style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.12)" }}
                                                item
                                                md={5}
                                            >
                                                <Box px={3}>
                                                    <lable className={classes.label}>نام محصول</lable>
                                                    <TextField
                                                        fullWidth
                                                        name="Title"
                                                        variant="outlined"
                                                        value={values.Title}
                                                        onChange={handleChange}
                                                        error={touched.Title && Boolean(errors.Title)}
                                                        helperText={touched.Title && errors.Title}
                                                    />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <div className={classes.label}>
                                                        قیمت محصول(به تومان)
                                                    </div>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        name="UnitPrice"
                                                        value={values.UnitPrice}
                                                        onChange={handleChange}
                                                        error={touched.UnitPrice && Boolean(errors.UnitPrice)}
                                                        helperText={touched.UnitPrice && errors.UnitPrice}
                                                    />
                                                    {(isBulkSale) && (
                                                        <Typography variant="caption" className={classes.mute} display="block" gutterBottom>
                                                            *قیمت یک کیلوگرم
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box textAlign="center">
                                                    <Radio
                                                        id="fale"
                                                        checked={values.bulkSale === true}
                                                        onChange={() => {
                                                            setFieldValue("bulkSale", true)
                                                            setIsBulkSale(true)
                                                        }}
                                                        value={true}
                                                        name="radio-button-demo"
                                                    />
                                                    <label style={{ marginTop: "5px", cursor: "pointer" }} htmlFor="fale">فله</label>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <Radio
                                                        id="pack"
                                                        checked={values.bulkSale === false}
                                                        onChange={() => {
                                                            setFieldValue("bulkSale", false);
                                                            setIsBulkSale(false)
                                                        }}
                                                        value={false}
                                                        name="radio-button-demo"
                                                    />
                                                    <label
                                                        style={{ marginTop: "5px", cursor: "pointer" }}
                                                        htmlFor="pack"
                                                    >
                                                        بسته ای
                        </label>
                                                </Box>

                                                <Box px={3} mt={2}>
                                                    <Typography className={classes.lable}>
                                                        موجودی انبار
                        </Typography>
                                                    <Box
                                                        borderRadius={10}
                                                        px={2}
                                                        pt={1}
                                                        pb={3}
                                                        border="0.3px solid #A7A7A7"
                                                        mt={1}
                                                    >
                                                        <Grid container>
                                                            {(isBulkSale) && (
                                                                <Grid item md={5}>

                                                                    <Typography className={classes.lable}>
                                                                        بسته
                                                                    </Typography>
                                                                    <Box mt={2}>250 گرمی</Box>
                                                                    <Box mt={3}>500 گرمی</Box>
                                                                    <Box mt={3.2}>1000 گرمی</Box>
                                                                </Grid>
                                                            )}
                                                            <Grid item md={isBulkSale ? 7 : 12}>
                                                                <Typography className={classes.lable}>
                                                                    تعداد
                                                                </Typography>
                                                                <Box mt={1}>
                                                                    <TextField
                                                                        fullWidth
                                                                        name="NumberPack250"
                                                                        variant="outlined"
                                                                        value={values.NumberPack250}
                                                                        onChange={handleChange}
                                                                        error={
                                                                            touched.NumberPack250 &&
                                                                            Boolean(errors.NumberPack250)
                                                                        }
                                                                        helperText={
                                                                            touched.NumberPack250 &&
                                                                            errors.NumberPack250
                                                                        }
                                                                    />
                                                                </Box>
                                                                {(isBulkSale) && (
                                                                    <>
                                                                        <Box mt={0.3}>
                                                                            <TextField
                                                                                fullWidth
                                                                                name="NumberPack500"
                                                                                variant="outlined"
                                                                                value={values.NumberPack500}
                                                                                onChange={handleChange}
                                                                                error={
                                                                                    touched.NumberPack500 &&
                                                                                    Boolean(errors.NumberPack500)
                                                                                }
                                                                                helperText={
                                                                                    touched.NumberPack500 &&
                                                                                    errors.NumberPack500
                                                                                }
                                                                            />
                                                                        </Box>
                                                                        <Box mt={0.3}>
                                                                            <TextField
                                                                                fullWidth
                                                                                name="NumberPack1000"
                                                                                variant="outlined"
                                                                                value={values.NumberPack1000}
                                                                                onChange={handleChange}
                                                                                error={
                                                                                    touched.NumberPack1000 &&
                                                                                    Boolean(errors.NumberPack1000)
                                                                                }
                                                                                helperText={
                                                                                    touched.NumberPack1000 &&
                                                                                    errors.NumberPack1000
                                                                                }
                                                                            />
                                                                        </Box>
                                                                    </>
                                                                )}
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item md={7}>
                                                <Box px={3}>
                                                    <lable className={classes.label}>
                                                        عنوان خواص محصول
                        </lable>
                                                    <TextField
                                                        fullWidth
                                                        name="PropertiesTitle"
                                                        variant="outlined"
                                                        value={values.PropertiesTitle}
                                                        onChange={handleChange}
                                                        error={
                                                            touched.PropertiesTitle &&
                                                            Boolean(errors.PropertiesTitle)
                                                        }
                                                        helperText={
                                                            touched.PropertiesTitle && errors.PropertiesTitle
                                                        }
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>متن خواص محصول</lable>

                                                    <Editor
                                                        editorState={editorState}
                                                        onEditorStateChange={(value) => setEditorState(value)}
                                                        wrapperClassName="demo-wrapper"
                                                        editorClassName="demo-editor"
                                                        textAlignment="right"
                                                        toolbar={{
                                                            inline: { inDropdown: true },
                                                            list: { inDropdown: true },
                                                            textAlign: { inDropdown: true },
                                                            link: { inDropdown: true },
                                                            history: { inDropdown: true },
                                                            image: { alt: { present: true, mandatory: true } },
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Box
                                        pt={3}
                                        pb={3}
                                        className={arabic ? classes.show : classes.hide}
                                        bgcolor="#fff"
                                    >
                                        <Grid container>
                                            <Grid
                                                style={{ borderLeft: "1px solid rgba(0, 0, 0, 0.12)" }}
                                                item
                                                md={5}
                                            >
                                                <Box px={3}>
                                                    <lable className={classes.label}>
                                                        نام محصول(به عربی)
                        </lable>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        name="ArTitle"
                                                        value={values.ArTitle}
                                                        onChange={handleChange}
                                                    />
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <lable className={classes.label}>
                                                        قیمت محصول (ریال)
                        </lable>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        name="ArUnitPrice"
                                                        value={values.ArUnitPrice}
                                                        onChange={handleChange}
                                                    />
                                                    <Typography
                                                        variant="caption"
                                                        className={classes.mute}
                                                        display="block"
                                                        gutterBottom
                                                    >
                                                        *قیمت یک کیلوگرم
                        </Typography>
                                                </Box>
                                                <Box px={3} mt={2}>
                                                    <Typography className={classes.lable}>
                                                        موجودی انبار
                        </Typography>
                                                    <Box
                                                        borderRadius={10}
                                                        px={2}
                                                        pt={1}
                                                        pb={3}
                                                        border="0.3px solid #A7A7A7"
                                                        mt={1}
                                                    >
                                                        <Grid container>
                                                            <Grid item md={5}>
                                                                <Typography className={classes.lable}>
                                                                    بسته
                              </Typography>
                                                                <Box mt={2}>250 گرمی</Box>
                                                                <Box mt={3}>500 گرمی</Box>
                                                                <Box mt={3.2}>1000 گرمی</Box>
                                                            </Grid>
                                                            <Grid item md={7}>
                                                                <Typography className={classes.lable}>
                                                                    تعداد
                              </Typography>
                                                                <Box mt={1}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        name="NumberPack250"
                                                                        disabled
                                                                        value={values.NumberPack250}
                                                                        onChange={handleChange}
                                                                    />
                                                                </Box>
                                                                <Box mt={0.3}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        name="NumberPack500"
                                                                        disabled
                                                                        value={values.NumberPack500}
                                                                        onChange={handleChange}
                                                                    />
                                                                </Box>
                                                                <Box mt={0.3}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        name="NumberPack1000"
                                                                        disabled
                                                                        value={values.NumberPack1000}
                                                                        onChange={handleChange}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item md={7}>
                                                <Box px={3}>
                                                    <lable className={classes.label}>
                                                        عنوان خواص محصول(به عربی)
                        </lable>
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        name="ArPropertiesTitle"
                                                        value={values.ArPropertiesTitle}
                                                        onChange={handleChange}
                                                    />
                                                </Box>
                                                <Box px={3} mt={1}>
                                                    <lable className={classes.label}>
                                                        متن خواص محصول(به عربی)
                        </lable>
                                                    <TextField
                                                        fullWidth
                                                        multiline
                                                        variant="outlined"
                                                        name="ArPropertiesText"
                                                        value={values.ArPropertiesText}
                                                        onChange={handleChange}
                                                        rows={15}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                            <br />
                            <Button
                                disabled={loading}
                                color="secondary"
                                variant="contained"
                                fullWidth
                                type="submit"
                            >
                                {!loading ? (
                                    "ثبت محصول"
                                ) : (
                                    <CircularProgress size={25} color="inherit" />
                                )}
                            </Button>
                        </form>
                    )}
                ></Formik>
                <Snackbar
                    open={alert.open}
                    autoHideDuration={4000}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    onClose={toggleCloseAlert}>
                    <Alert onClose={toggleCloseAlert} severity={alert.type}>
                        {alert.message}
                    </Alert>
                </Snackbar>
            </Box>
        </Box>
    )
}

export default ProductInsert
